/**
 * Makes every link to an outside site open in a new tab, automatically —
 * no need to set "open in new tab" per link in the editor.
 *
 * "External" = a different hostname than the current one, excluding this
 * shop's own myshopify.com domain (so a link never accidentally targets the
 * checkout/account flow on a different tab). mailto:/tel:/sms:/javascript:
 * links and anchors already left alone. A link with an explicit `target`
 * attribute is left as-is (its author already made a deliberate choice).
 *
 * Runs once on load, then a MutationObserver catches links added later —
 * cart drawer, quick add modal, mega menus, search results, etc.
 */
(function () {
  var currentHost = window.location.hostname;

  function isInternalHost(host) {
    if (!host) return true;
    if (host === currentHost) return true;
    if (host.slice(-13) === '.myshopify.com') return true;
    return false;
  }

  function markExternalLinks(root) {
    var links = (root || document).querySelectorAll('a[href]:not([data-ext-checked])');
    links.forEach(function (a) {
      a.setAttribute('data-ext-checked', '1');

      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      if (/^(mailto:|tel:|sms:|javascript:)/i.test(href)) return;
      if (a.hasAttribute('target')) return;

      var url;
      try {
        url = new URL(href, window.location.href);
      } catch (e) {
        return;
      }

      if (url.protocol !== 'http:' && url.protocol !== 'https:') return;
      if (isInternalHost(url.hostname)) return;

      a.setAttribute('target', '_blank');

      var rel = (a.getAttribute('rel') || '').split(/\s+/).filter(Boolean);
      if (rel.indexOf('noopener') === -1) rel.push('noopener');
      if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
      a.setAttribute('rel', rel.join(' '));
    });
  }

  markExternalLinks();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          markExternalLinks(document);
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
